$(document).ready(() => {
  $('.categories-tree select').last().trigger('change')
})

$('body').on('change', '.categories-tree select', function () {
  const $selects = $('.categories-tree select')
  const $this = $(this)

  $selects.attr('readonly', true)

  $selects.each(function () {
    if (parseInt($(this).data('count')) > parseInt($this.data('count'))) {
      $(this).closest('.col').remove()
    }
  })

  if ($this.val().length > 0) {
    $this.attr('name', 'parent_id')

    axios.post('/categories/' + $this.val() + '/' + 'get-children-items').then(response => {
      if (response.status === 200 && response.data.status === 'success') {
        if (response.data.data.length) {
          $('.categories-tree').append(
            $('<div/>').addClass('col').append(
              $('<div/>').addClass('form-group').append(
                $('<div/>').addClass('input-group').append(
                  $('<select/>').addClass('form-control').data('count', parseInt($this.data('count')) + 1).append(
                    $('<option/>').attr('selected', true)
                  )
                )
              )
            )
          )

          response.data.data.forEach(el => {
            $('.categories-tree select').last().append(
              $('<option/>').val(el.id).text(el.name)
            )
          })
        }
      } else {
        toastr.error('Не удалось загрузить дочерние категории')
      }
    }).catch(() => {
      toastr.error('Не удалось загрузить дочерние категории')
    })
  }

  $selects.removeAttr('readonly')
})